<script>
import BasePublicationsVariantsExpansionTable from '@/components/admin/collector/publications/BasePublicationsVariantsExpansionTable.vue'

export default {
  name: 'PublicationsVariantsExpansionTable',
  extends: BasePublicationsVariantsExpansionTable,
}
</script>
